import { ReactNode } from "react";

import Typography from "../Typography";

type ConfirmationModalMessageProps = {
  children: ReactNode;
};

export const ConfirmationModalMessage = ({ children }: ConfirmationModalMessageProps) => {
  return <Typography tag="p">{children}</Typography>;
};

ConfirmationModalMessage.displayName = "DS.ConfirmationModal.Message";
